<div class="component-post-view">
  <p class="component-post-view__go-back-button" routerLink="/">Go Back To Reports</p>
  <div class="component-post-view__image" [style.background-image]="blogImage" *ngIf="postData.post_image"></div>
  <h2><span>{{postData.post_name}}</span></h2>
  <h3><span>{{postData.post_category}}</span></h3>
  <div class="component-post-view__content" [innerHTML]="blogData">
  </div>
</div>
